import { Checkbox, Text } from '@croquiscom-pvt/zds';
import styled from '@emotion/styled';

import { TouchAccessibilityWrapper } from '@domains/pdp-common';

import { CheckboxItem } from '../../types/benefit';

export const CheckboxSubItem = (subItem: CheckboxItem) => {
  return (
    <TouchAccessibilityWrapper onClick={() => subItem.onChecked?.(subItem.checked)}>
      <Container key={subItem.content}>
        <LeftWrap key={subItem.content}>
          <Checkbox size='small' checked={subItem.checked} style={{ display: 'flex', alignItems: 'baseline' }} />
          <Text variant='Body_13_Medium' color='textSecondary'>
            {subItem.content}
          </Text>
        </LeftWrap>
        <Text
          variant='Body_13_SemiBold'
          color={subItem.checked ? 'textStrong' : 'textDisabled'}
          style={{ whiteSpace: 'pre' }}
        >
          {subItem.subContent}
        </Text>
      </Container>
    </TouchAccessibilityWrapper>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
`;

const LeftWrap = styled.div`
  display: flex;
  gap: 8px;
`;
